import React from "react";

const LessonRow = ({
    page,
    index,

    activeNotebookPageId,

    editingPageId,
    editingPageTitle,
    setEditingPageTitle,

    editingChapterTitle,
    setEditingChapterTitle,

    editingSectionTitle,
    setEditingSectionTitle,

    openNotebookPage,
    startEditingPage,
    saveEditingPage,
    cancelEditingPage,
    deleteNotebookPage,

    chapterNames,
    moveNotebookPage,

    draggedLessonId,
    setDraggedLessonId,
    moveLessonWithinChapter,
    }) => {
    const isActive =
        activeNotebookPageId ===
        page.id;

    const isEditing =
        editingPageId ===
        page.id;

    const [
        isMoveOpen,
        setIsMoveOpen,
    ] = React.useState(false);

    const [
        moveChapter,
        setMoveChapter,
    ] = React.useState(
        page.chapterTitle || ""
    );
    return (  
        <div
            draggable={!isEditing}
            onDragStart={(event) => {
                event.stopPropagation();

                if (!isEditing) {
                    setDraggedLessonId(
                        page.id
                    );
                }
            }}
            onDragEnd={(event) => {
                event.stopPropagation();

                setDraggedLessonId(
                    null
                );
            }}
            onDragOver={(event) => {
                if (!isEditing) {
                    event.preventDefault();
                }
            }}
            onDrop={(event) => {
                if (isEditing) {
                    return;
                }

                event.preventDefault();

                moveLessonWithinChapter(
                    page.id,
                    page.chapterTitle?.trim() ||
                        "Unassigned"
                );
            }}
            className={`
                rounded-lg
                border
                transition
                ${
                    draggedLessonId ===
                    page.id
                        ? "opacity-60"
                        : ""
                }
                ${
                    isActive
                        ? "border-[#ffd166]/60 bg-[#ffd166]/10"
                        : "border-[#ffd166]/10 bg-black/35"
                }
            `}
        >
{isEditing ? (  
    <div className="space-y-2 p-3">

        <input
            type="text"
            value={
                editingPageTitle
            }
            onChange={(event) =>
                setEditingPageTitle(
                    event.target.value
                )
            }
            placeholder="Lesson title"
            className="
                w-full
                rounded-lg
                border
                border-[#ffd166]/30
                bg-black
                px-3
                py-2
                text-sm
                text-[#fff3c4]
                outline-none
                focus:border-[#ffd166]
            "
        />

        <input
            type="text"
            value={
                editingChapterTitle
            }
            
                        onChange={(event) =>
                            setEditingChapterTitle(
                                event.target.value
                            )
                        }
                        placeholder="Chapter or Unit"
                        className="
                            w-full
                            rounded-lg
                            border
                            border-[#c084fc]/30
                            bg-black
                            px-3
                            py-2
                            text-xs
                            text-[#fff3c4]
                            outline-none
                            focus:border-[#c084fc]
                        "
                    />

                    <input
                        type="text"
                        value={
                            editingSectionTitle
                        }
                        onChange={(event) =>
                            setEditingSectionTitle(
                                event.target.value
                            )
                        }
                        placeholder="Section or topic"
                        className="
                            w-full
                            rounded-lg
                            border
                            border-[#c084fc]/30
                            bg-black
                            px-3
                            py-2
                            text-xs
                            text-[#fff3c4]
                            outline-none
                            focus:border-[#c084fc]
                        "
                    />

                    <div className="flex flex-wrap gap-2">
                        <button
                            type="button"
                            onClick={
                                saveEditingPage
                            }
                            className="
                                rounded-lg
                                border
                                border-[#ffd166]/45
                                bg-[#2b1548]/70
                                px-2.5
                                py-1.5
                                text-[10px]
                                font-semibold
                                text-[#ffd166]
                            "
                        >
                            Save
                        </button>

                        <button
                            type="button"
                            onClick={
                                cancelEditingPage
                            }
                            className="
                                rounded-lg
                                border
                                border-[#c084fc]/30
                                bg-black
                                px-2.5
                                py-1.5
                                text-[10px]
                                text-[#d8b4fe]
                            "
                        >
                            Cancel
                        </button>
                    </div>
                </div>
            ) : (
                <>
                <div className="flex items-start gap-2 p-2.5">
                    <button
                        type="button"
                        onClick={() =>
                            openNotebookPage(
                                page
                            )
                        }
                        className="
                            min-w-0
                            flex-1
                            text-left
                        "
                    >
                        <div className="flex items-start gap-2">
                            <span className="mt-0.5 shrink-0 text-[10px] font-semibold text-[#8f98b5]">
                                {page.lessonNumber ||
                                    index +
                                        1}
                                .
                            </span>

                            <div className="min-w-0 flex-1">
                                <p className="text-sm font-semibold text-[#fff3c4]">
                                    {page.title ||
                                        "Untitled Lesson"}
                                </p>

                                {page.sectionTitle && (
                                    <p className="mt-1 text-[10px] uppercase tracking-[0.14em] text-[#b0b8d6]">
                                        {
                                            page.sectionTitle
                                        }
                                    </p>
                                )}
                            </div>
                        </div>
                    </button>

                    <div className="flex shrink-0 flex-wrap gap-1">
                        <button
                            type="button"
                            onClick={() =>
                                startEditingPage(
                                    page
                                )
                            }
                            className="
                                rounded-lg
                                border
                                border-[#c084fc]/30
                                bg-black
                                px-2
                                py-1
                                text-[10px]
                                text-[#d8b4fe]
                                transition
                                hover:border-[#ffd166]
                                hover:text-[#ffd166]
                            "
                        >
                            Edit
                        </button>
                    
                    <button
                        type="button"
                        onClick={() => {
                            setMoveChapter(
                                page.chapterTitle || ""
                            );

                            setIsMoveOpen(
                                (current) =>
                                    !current
                            );
                        }}
                        className="
                            rounded-lg
                            border
                            border-[#7cc1ff]/30
                            bg-black
                            px-2
                            py-1
                            text-[10px]
                            text-[#9dcff5]
                            transition
                            hover:border-[#ffd166]
                            hover:text-[#ffd166]
                        "
                    >
                        Move
                    </button>
                        <button
                            type="button"
                            onClick={() =>
                                deleteNotebookPage(
                                    page.id
                                )
                            }
                            className="
                                rounded-lg
                                border
                                border-red-400/30
                                bg-black
                                px-2
                                py-1
                                text-[10px]
                                text-red-200
                                transition
                                hover:border-red-300
                                hover:text-red-100
                            "
                        >
                            Delete
                        </button>
                    </div>
                                </div>

                {isMoveOpen && (
                    <div
                        className="
                            border-t
                            border-[#7cc1ff]/15
                            bg-[#07121d]/70
                            p-2.5
                        "
                    >
                        <p className="mb-2 text-[10px] font-semibold uppercase tracking-[0.14em] text-[#9dcff5]">
                            Move to Chapter
                        </p>

                        <div className="flex flex-wrap items-center gap-2">
                            <select
                                value={
                                    moveChapter
                                }
                                onChange={(event) =>
                                    setMoveChapter(
                                        event.target.value
                                    )
                                }
                                className="
                                    min-w-[160px]
                                    flex-1
                                    rounded-lg
                                    border
                                    border-[#7cc1ff]/30
                                    bg-black
                                    px-2
                                    py-1.5
                                    text-xs
                                    text-[#fff3c4]
                                    outline-none
                                    focus:border-[#ffd166]
                                "
                            >
                                <option value="">
                                    Unassigned
                                </option>

                                {chapterNames.map(
                                    (chapterName) => (
                                        <option
                                            key={
                                                chapterName
                                            }
                                            value={
                                                chapterName
                                            }
                                        >
                                            {
                                                chapterName
                                            }
                                        </option>
                                    )
                                )}
                            </select>

                            <button
                                type="button"
                                onClick={() => {
                                    moveNotebookPage(
                                        page.id,
                                        moveChapter
                                    );

                                    setIsMoveOpen(
                                        false
                                    );
                                }}
                                className="
                                    rounded-lg
                                    border
                                    border-[#ffd166]/45
                                    bg-[#2b1548]/70
                                    px-3
                                    py-1.5
                                    text-[10px]
                                    font-semibold
                                    text-[#ffd166]
                                    transition
                                    hover:border-[#ffd166]
                                "
                            >
                                Move
                            </button>

                            <button
                                type="button"
                                onClick={() =>
                                    setIsMoveOpen(
                                        false
                                    )
                                }
                                className="
                                    rounded-lg
                                    border
                                    border-[#c084fc]/30
                                    bg-black
                                    px-3
                                    py-1.5
                                    text-[10px]
                                    text-[#d8b4fe]
                                "
                            >
                                Cancel
                            </button>
                                                </div>
                    </div>
                )}

                </>
            )}
        </div>
    );
};

export default LessonRow;